export default class MChat {
    constructor(selectedConversationId, broadcastToListen) {
        this.selectedConversationId = selectedConversationId;
        this.broadcastToListen = broadcastToListen;
    }

    init = () => {
        var _this = this;
        jQuery(document).ready(function() {
            _this.subscribeToPresenceChannel(_this.selectedConversationId);
            _this.listenToBroadcastEvents();
            
            Livewire.on('conversationChanged', (selectedConversationId, previousConversationId) => {
                _this.subscribeToPresenceChannel(selectedConversationId, previousConversationId);
            });
            
            Livewire.on('messageSentDone', () => {
                
            });

            Livewire.on('conversationInited', (selectedConversation, messagesIndexUrl) => {
                history.pushState(null, null, messagesIndexUrl);
            });

            window.addEventListener('popstate', function (event) {
                var pathname = event.target.location.pathname;
                var conversationUuid = pathname.replace(/\/\w+\/messaggi\/\w+\/?/i, '');
                Livewire.emit('reinitAfterHistoryPopped', conversationUuid);
            });

            Livewire.emit('conversationRead', _this.selectedConversationId);

            _this.autosize();
        });
    }

    autosize = () => {
        var text = $('.autosize');

        text.each(
            function() {
                $(this).attr('rows',1);
                resize($(this));
            }
        );

        text.on('input', function(){
            resize($(this));
        });

        function resize ($text) {
            $text.css('height', 'auto');
            $text.css('height', $text[0].scrollHeight+'px');
        }
    }

    showOtherTextingNotice = () => {
        jQuery('.someone-is-texting').removeClass('d-none');
        setTimeout(function() {
            jQuery('.someone-is-texting').addClass('d-none');
        }, 3000);
    }

    listenToBroadcastEvents = () => {
        _.forEach(this.broadcastToListen, function(broadcastChannel) {
            Echo.private(broadcastChannel)
                .listen('ChatMessageCreated', (e) => {
                    Livewire.emit('chatMessageCreated');
                });
        });
    }

    subscribeToPresenceChannel = (selectedConversationId, previousConversationId = false) => {
        if (previousConversationId !== false) {
            Echo.leave('Myosotis.Models.Conversation.' + previousConversationId);
        }

        Echo.join('Myosotis.Models.Conversation.' + selectedConversationId)
            .joining((user) => {
                //console.log("JOINING: " + user.name);
            })
            .leaving((user) => {
                //console.log("LEAVING: " + user.name);
            })
            .listen('ChatMessageCreating', (e) => {
                this.showOtherTextingNotice();
            });
    }
}